import React from "react"

const ModalActuacionContent = ({ children }) => {
  return (
    <div className="antuacionContent-container">
      {children[0] && <div className="centerImage">{children[0]}</div>}
      {children[1] && <div className="sectionSides">{children[1]}</div>}
      {children[2] && <div className="sectionIcons">{children[2]}</div>}
      {children[3] && <div className="sectionLeft">{children[3]}</div>}
      {children[4] && <div className="sectionRight">{children[4]}</div>}
      {children[5] && <div className="sectionLeft">{children[5]}</div>}
      {children[6] && <div className="sectionLeft">{children[6]}</div>}
    </div>
  )
}

export default ModalActuacionContent
